"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _url = require("url");
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _classnames = _interopRequireDefault(require("classnames"));
var _PillLink = _interopRequireDefault(require("../../PillLink"));
var _EditableLabels = _interopRequireDefault(require("../../EditableLabels"));
var _EmptyMetadataEditMode = _interopRequireDefault(require("../EmptyMetadataEditMode"));
var _events = require("../events");
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var LabelsIcon = function LabelsIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.496 0h15.03l5.224 7.5-5.224 7.5H1.496A19.44 19.44 0 0 1 0 7.5C0 4.842.533 2.309 1.496 0Zm1.028 13.5h13.218l4.18-6-4.18-6H2.524a17.908 17.908 0 0 0-1.024 6c0 2.065.344 4.079 1.024 6ZM14.25 5.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM13.5 7.5a.75.75 0 0 0 1.5 0 .75.75 0 0 0-1.5 0Z"
  }));
};
LabelsIcon.defaultProps = {
  viewBox: "0 0 22 15",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "icon": "CustomerMetadata__icon__1eFWZ",
  "dropdown-icon": "CustomerMetadata__dropdown-icon__1fowq",
  "dropdownIcon": "CustomerMetadata__dropdown-icon__1fowq",
  "metadata-item": "CustomerMetadata__metadata-item__1rfCM",
  "metadataItem": "CustomerMetadata__metadata-item__1rfCM",
  "metadata-item-wrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "metadataItemWrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "extendable": "CustomerMetadata__extendable__GmS9B",
  "editable": "CustomerMetadata__editable__2RE1j",
  "metadata": "CustomerMetadata__metadata__2OWHW",
  "popover": "CustomerMetadata__popover__ozLWy",
  "metadata-row": "CustomerMetadata__metadata-row__38kip",
  "metadataRow": "CustomerMetadata__metadata-row__38kip"
}; 
require('../CustomerMetadata.css');
var labelsStyles = {
  "container": "Labels__container__7glLh",
  "labels-title": "Labels__labels-title___U-Iz",
  "labelsTitle": "Labels__labels-title___U-Iz",
  "labels-container": "Labels__labels-container__1VM1F",
  "labelsContainer": "Labels__labels-container__1VM1F"
}; 
require('./Labels.css');
var BOTTOM_LEFT_POSITION = 'bl';
var DOWN_POSITION = 'd';
var Labels = function Labels(_ref) {
  var _ref$canEdit = _ref.canEdit,
    canEdit = _ref$canEdit === void 0 ? false : _ref$canEdit,
    asset = _ref.asset;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var getTagURL = function getTagURL(tagName) {
    var pathname = getPath('home');
    var query = {
      search: "tag:\"".concat(tagName, "\""),
      show: 'all'
    };
    return (0, _url.format)({
      pathname: pathname,
      query: query
    });
  };
  var renderPopoverModal = function renderPopoverModal() {
    if (canEdit) {
      return /*#__PURE__*/_react.default.createElement(_EditableLabels.default, {
        asset: asset
      });
    }
    return /*#__PURE__*/_react.default.createElement("section", {
      "data-test-id": "asset-labels-list",
      "aria-labelledby": "tags-heading",
      className: labelsStyles.container
    }, /*#__PURE__*/_react.default.createElement("h2", {
      id: "tags-heading",
      className: "visually-hidden"
    }, "Tags"), /*#__PURE__*/_react.default.createElement("div", {
      className: labelsStyles.labelsContainer,
      "aria-live": "polite"
    }, (asset.labels || []).map(function (label, index) {
      return /*#__PURE__*/_react.default.createElement(_PillLink.default
      // eslint-disable-next-line react/no-array-index-key
      , {
        key: "tag-".concat(index),
        to: getTagURL(label),
        "aria-label": "Go to tag ".concat(label),
        title: label,
        disabled: true
      }, label);
    })));
  };
  var popoverContainer = _react.default.useRef(null);
  var renderMetadataContent = function renderMetadataContent() {
    var _asset$labels;
    if (canEdit && !((_asset$labels = asset.labels) !== null && _asset$labels !== void 0 && _asset$labels.length)) {
      return /*#__PURE__*/_react.default.createElement(_EmptyMetadataEditMode.default, {
        metadataType: "tags"
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": "labels-metadata-item-test",
      className: (0, _classnames.default)(styles.metadataItemWrapper, styles.extendable)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.icon,
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement(LabelsIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.metadataItem,
      id: "labels-metadata-item"
    }, "Tags (".concat(asset.labels.length, ")")), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test-id": "drowpdown-arrow-icon",
      className: styles.dropdownIcon,
      size: "xs"
    }, /*#__PURE__*/_react.default.createElement(ArrowIcon, null)));
  };
  if (!canEdit && !asset.labels.length) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "labels-container",
    ref: popoverContainer
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    onOpen: function onOpen() {
      return trackEvent(_events.EVENT_TYPES.EXPANDING_TAGS);
    },
    anchorPosition: BOTTOM_LEFT_POSITION,
    popupPosition: DOWN_POSITION,
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.current;
    },
    content: renderPopoverModal(),
    closeOnClickInside: true
  }, renderMetadataContent()));
};
var _default = exports.default = Labels;
//# sourceMappingURL=Labels.js.map